import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { stateLocations, heroStates } from '../data/states';

const StateGrid = () => {
  const featured = heroStates.map((slug) => stateLocations.find((s) => s.slug === slug)).filter(Boolean);

  return (
    <section className="bg-white py-16 md:py-20" data-testid="state-grid">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">VPOB by Location</div>
            <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 leading-[1.1]">
              Virtual office available in{' '}
              <span className="relative inline-block text-[#F39200]">30+ locations
                <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 260 10" fill="none">
                  <path d="M2 7 C 60 1, 150 1, 258 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
                </svg>
              </span>
            </h2>
            <p className="mt-4 text-[15px] text-neutral-600">
              Section 35-compliant addresses across every major Amazon, Flipkart and Meesho fulfilment state.
            </p>
          </div>
          <Link
            to="/vpob-apob"
            data-testid="see-all-states-link"
            className="inline-flex items-center gap-2 text-[#F39200] hover:text-[#E08400] font-semibold text-sm"
          >
            See all states <ArrowRight size={16} />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {featured.map((s) => (
            <Link
              key={s.slug}
              to={`/virtual-office-in/${s.slug}`}
              data-testid={`state-tile-${s.slug}`}
              className="group bg-white border border-black/5 rounded-2xl p-4 hover:border-[#F39200] hover:shadow-md transition-all"
            >
              <div className="w-10 h-10 rounded-lg bg-[#FAF2E8] text-[#F39200] flex items-center justify-center font-extrabold text-sm">
                {s.code}
              </div>
              <div className="mt-3 text-sm font-semibold text-neutral-900">{s.name}</div>
              <div className="mt-1 text-[11px] text-neutral-500 flex items-center gap-1">
                <MapPin size={11} /> {s.cities[0]}{s.cities.length > 1 ? ` +${s.cities.length - 1}` : ''}
              </div>
              <div className="mt-3 text-xs text-neutral-600">
                From <span className="font-bold text-neutral-900">₹{s.price}</span>
                <span className="text-neutral-400">/month</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StateGrid;
